import React from 'react'
import { createBrowserRouter } from 'react-router-dom'

// Use lazy loading to avoid circular import dependencies during test setup
const AppWrapper = React.lazy(() => import('@app/_init/components/AppWrapper'))

/**
 * Main application router using React Router v6 Data Router API.
 *
 * Uses a catch-all route that renders AppWrapper, which contains the App component.
 * This preserves the existing RBAC routing logic in RbacRoutes while using
 * the stable RouterProvider API instead of unstable_HistoryRouter.
 */
export const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <React.Suspense fallback={null}>
        <AppWrapper />
      </React.Suspense>
    )
  }
])
